module.exports = __webpack_public_path__ + "img/vc.eed4cd04.svg";